import styled, { createGlobalStyle } from 'styled-components';
import { Card, Dropdown, Tag, Tabs, Radio, Input } from 'antd';

/** Ant Design v5 has no xxxl breakpoint (added in v6.3.0). Use this + className="col-xxxl-4" on Col for 1920px+ */
export const ColXxxlGridStyle = createGlobalStyle`
  @media (min-width: 1920px) {
    .col-xxxl-4.ant-col {
      flex: 0 0 16.666667% !important;
      max-width: 16.666667% !important;
    }
  }
`;

export const ThemeProjectSmallTitle = styled.div`
  font-family: ${({ theme }) => theme.fonts.inter} !important;
  font-size: 14px;
  line-height: 24px;
  font-weight: 500;
  color: ${({ theme }) => theme.settings.primary};
`;
// new style
export const ThemeProjectTabWrapper = styled.div`
  .view-toggle {
    display: inline-flex;
    border-radius: 10px;
    background: ${({ theme }) => theme.settings.whiteColor};
    overflow: hidden;
    border: 1px solid ${({ theme }) => theme.settings.borderColor};
    .toggle-btn {
      font-family: ${({ theme }) => theme.fonts.inter} !important;
      padding: 10px 24px;
      font-size: 10px;
      line-height: 12px;
      font-weight: 600;
      border: none;
      background: transparent;
      color: ${({ theme }) => theme.settings.primary};
      border: 2px solid transparent;
      cursor: pointer;
      transition: all 0.25s ease;
      border-radius: 10px;
    }
    .toggle-btn.active {
      background: ${({ theme }) => theme.settings.whiteColor};
      color: ${({ theme }) => theme.settings.mainColor};
      border: 2px solid ${({ theme }) => theme.settings.mainColor};
    }
    .toggle-btn:not(.active):hover {
      background: ${({ theme }) => theme.settings.whiteColor};
    }
  }
`;
export const ThemeProjectCard = styled(Card)`
  width: 100%;
  position: relative;
  height: 100%;
  display: flex;
  flex-direction: column;
  border-radius: 10px;
  background: transparent;
  font-family: ${({ theme }) => theme.fonts.inter} !important;
  border: 1px solid ${({ theme }) => theme.settings.borderColor};
  background: ${({ theme }) => theme.settings.whiteColor};
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    box-shadow: 0px 4px 12px rgba(50, 50, 50, 0.1);
  }

  &.skyBlueBorder {
    border-bottom: 4px solid ${({ theme }) => theme.settings.blueColor};
  }
  &.blueDarkBorder {
    border-bottom: 4px solid ${({ theme }) => theme.settings.blueDarkColor};
  }
  &.orangeBorder {
    border-bottom: 4px solid ${({ theme }) => theme.settings.orangeColor};
  }
  .ant-card-body {
    padding: 0px 20px 20px 20px;
    display: flex;
    flex-direction: column;
    flex: 1;
    gap: 12px;
  }
  .ant-card-body > .actionWrapper {
    margin-top: auto;
  }
  .ant-card-head {
    padding: 5px 20px;
    font-size: 16px;
    font-weight: 500;
    color: ${({ theme }) => theme.settings.secondary};
    border-bottom: none !important;
  }

  .title {
    font-family: ${({ theme }) => theme.fonts.inter};
    font-size: 16px;
    font-weight: 600;
    line-height: 26px;
    color: ${({ theme }) => theme.settings.primary};
  }
  .subTitle {
    font-size: 13px;
    font-weight: 400;
    line-height: 24px;
    color: ${({ theme }) => theme.settings.secondary};
    span {
      font-weight: 600;
    }
    .readMoreLink {
      font-size: 11px;
      font-weight: 500;
      color: ${({ theme }) => theme.settings.primary} !important;
      cursor: pointer;
      text-decoration: none;
      margin-left: 4px;
    }
    &.truncate-3-lines {
      display: -webkit-box;
      -webkit-line-clamp: 3;
      -webkit-box-orient: vertical;
      overflow: hidden;
      text-overflow: ellipsis;
      max-height: 72px;
    }
  }
  .actionWrapper {
    display: flex;
    align-items: flex-end;
    justify-content: space-between;
    gap: 10px;
    font-size: 12px;
    font-weight: 500;
    line-height: 18px;
    color: ${({ theme }) => theme.settings.textColor};
  }

  &.ant-card-loading {
    .ant-card-body {
      padding: 20px;
    }
  }
`;

export const ProjectNameLink = styled.span`
  cursor: pointer;
  color: ${({ theme }) => theme.settings.primary};
`;

export const ProjectTableActionWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
`;

export const CardDropdown = styled(Dropdown)`
  font-size: 20px;
  font-weight: 600;
  line-height: 24px;
  color: ${({ theme }) => theme.settings.mainColor};
  cursor: pointer;
`;
export const ProjectTag = styled(Tag)`
  font-size: 14px;
  font-weight: 500;
  line-height: 16px;
  background-color: transparent;
  color: ${({ theme }) => theme.settings.primary};
  border-radius: 0px;
  border: none;
  padding: 0px;
  margin: 0px;
`;
export const ProjectActiveTag = styled(Tag)`
  font-size: 14px;
  font-weight: 400;
  line-height: 16px;
  background-color: transparent;
  color: ${({ theme }) => theme.settings.secondary};
  border-radius: 4px;
  border: none;
  padding: 4px 10px;
  margin: 0px;
  &.skyBlueBorder {
    color: ${({ theme }) => theme.settings.blueColor};
    background-color: #42abde1a;
  }
  &.blueDarkBorder {
    color: ${({ theme }) => theme.settings.blueDarkColor};
    background-color: #5f42de1a;
  }
  &.orangeBorder {
    color: ${({ theme }) => theme.settings.orangeColor};
    background-color: #e65b5b1a;
  }

  &.bgSkyBlueBorder {
    display: inline-flex;
    align-items: center;
    color: ${({ theme }) => theme.settings.blueColor} !important;
    background: #42abde1a !important;
    padding: 4px 8px;
    font-size: 12px;
    border-radius: 5px;
    line-height: 1;
    img {
      width: 12px;
      height: 12px;
    }
  }
  &.bgGreenBorder {
    display: inline-flex;
    align-items: center;
    color: #fff !important;
    background: ${({ theme }) => theme.settings.greenColor} !important;
    padding: 4px 8px;
    font-size: 12px;
    border-radius: 5px;
    line-height: 1;
    img {
      width: 12px;
      height: 12px;
    }
  }
  &.bgOrangeBorder {
    display: inline-flex;
    align-items: center;
    color: ${({ theme }) => theme.settings.orangeColor} !important;
    background: #e65b5b1a !important;
    padding: 4px 8px;
    font-size: 12px;
    border-radius: 5px;
    line-height: 1;
    img {
      width: 12px;
      height: 12px;
    }
  }
`;
export const ProjectDetailsCard = styled(Card)`
  width: 100%;
  position: relative;
  height: 100%;
  background: ${({ theme }) => theme.settings.whiteColor};
  border-radius: 10px;
  border: 1px solid ${({ theme }) => theme.settings.borderColor};
  box-shadow: 0px 0px 8px rgba(50, 50, 50, 0.05);
  .ant-card-body {
    padding: 24px 28px;
  }
  &.compact-card {
    height: auto;
    .ant-card-body {
      padding: 16px 20px;
    }
  }
  .cardTitle {
    font-family: ${({ theme }) => theme.fonts.inter} !important;
    font-size: 14px;
    font-weight: 500;
    line-height: 18px;
    color: ${({ theme }) => theme.settings.primary};
    min-height: 36px;
  }
  .cardNumber {
    font-family: ${({ theme }) => theme.fonts.inter} !important;
    font-size: 24px;
    font-weight: 600;
    line-height: 18px;
    color: ${({ theme }) => theme.settings.primary};
  }
  .cardTextNumber {
    font-family: ${({ theme }) => theme.fonts.inter} !important;
    font-size: 12px;
    font-weight: 500;
    line-height: 18px;
    color: ${({ theme }) => theme.settings.secondary};
    span {
      color: ${({ theme }) => theme.settings.primary};
      font-weight: 500;
    }
  }
  /* &.bgImages {
    z-index: 2;
    &:before {
      position: absolute;
      content: "";
      top: 0px;
      right: 10px;
      min-width: 120px;
      max-width: 100%;
      height: 150px;
      background-size: contain;
      z-index: 1;
    }
  }
   &.uploadDocuments {
    &:before {
      background: url("/images/upload-docs-bg.svg") no-repeat center right;
    }
  }
  &.insights {
    &:before {
      background: url("/images/project-insights-bg.svg") no-repeat center right;
    }
  }
  &.activeDiscs {
    &:before {
      background: url("/images/project-active-discs.svg") no-repeat center right;
    }
  } */
`;
// new style
export const ProjectMainDetails = styled.div`
  width: 100%;
  position: relative;
  border-radius: 10px;
  overflow: hidden;
  padding: 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 103px;
  background: #fff;
  border: 1px solid #e8eaf6;
  box-shadow:
    0px 6px 29px 0px rgba(89, 108, 148, 0.07),
    0px 0.75px 3.63px 0px rgba(89, 108, 148, 0.04);
  .stat-icon {
    flex-shrink: 0;
    width: 54px;
    height: 54px;
    img {
      width: 54px;
      height: 54px;
    }
  }
  .stat-text {
    flex: 1;
    min-width: 0;
  }
  .stat-label {
    font-family: 'Montserrat', sans-serif;
    font-size: 14px;
    font-weight: 500;
    color: rgba(31, 36, 48, 0.6);
    margin-bottom: 8px;
    line-height: 18px;
  }
  .stat-number {
    font-family: 'Montserrat', sans-serif;
    font-size: 24px;
    font-weight: 600;
    color: #2c2926;
    line-height: 18px;
  }
`;
export const ProjectDetailsUploadCard = styled(Card)`
  width: 100%;
  position: relative;
  height: 100%;
  background: ${({ theme }) => theme.settings.whiteColor};
  border-radius: 10px;
  border: 1px solid ${({ theme }) => theme.settings.borderColor};
  .ant-card-body {
    padding: 0px;
  }
  &.filesUploadCard {
    height: auto;
    .ant-card-body {
      height: auto;
      max-height: none;
      overflow: visible;
    }
  }
  .ant-card-head {
    border-bottom: 1px solid ${({ theme }) => theme.settings.borderColor} !important;
    padding-bottom: 6px !important;
    @media (max-width: 768.99px) {
      padding: 10px 15px !important;
    }
    .ant-card-head-title {
      font-family: ${({ theme }) => theme.fonts.inter} !important;
      font-size: 16px;
      font-weight: 600;
      line-height: 20px;
      color: ${({ theme }) => theme.settings.primary};
      span {
        font-size: 12px;
        font-weight: 400;
        line-height: 18px;
        color: ${({ theme }) => theme.settings.secondary};
      }
    }
  }
  .fileName {
    font-family: ${({ theme }) => theme.fonts.inter} !important;
    font-size: 14px;
    font-weight: 500;
    line-height: 22px;
    color: ${({ theme }) => theme.settings.primary};
    min-width: 0;
    .title {
      overflow-wrap: anywhere;
      word-break: break-word;
    }
    .rawName {
      font-size: 11px;
      font-weight: 400;
      line-height: 16px;
      color: ${({ theme }) => theme.settings.secondary};
      opacity: 0.85;
      overflow-wrap: anywhere;
      word-break: break-all;
    }
    .smallText {
      display: flex;
      flex-wrap: wrap;
      align-items: center;
      gap: 4px 8px;
      margin-top: 4px;
      font-size: 12px;
      font-weight: 400;
      line-height: 16px;
      color: ${({ theme }) => theme.settings.secondary};
    }
  }
  td.fileNameCell {
    min-width: 0;
  }
  td.fileActionsCell {
    white-space: nowrap;
    .ant-space {
      flex-wrap: nowrap;
    }
  }
`;
export const ProjectDetailsTableCard = styled(Tabs)`
  width: 100%;
  position: relative;
  border: none;
  background: ${({ theme }) => theme.settings.whiteColor};
  padding: 0px;
  border: 1px solid ${({ theme }) => theme.settings.borderColor};
  border-radius: 16px;
  .ant-tabs-nav {
    padding: 10px 15px;
    margin-bottom: 0px !important;
  }
  .ant-tabs-nav-list {
    background: ${({ theme }) => theme.settings.whiteColor};
    border-radius: 40px;
    border: 1px solid ${({ theme }) => theme.settings.borderColor};
  }
  .ant-tabs-tab {
    font-family: ${({ theme }) => theme.fonts.inter} !important;
    background: transparent !important;
    border: none !important;
    border-radius: 40px !important;
    font-size: 14px !important;
    font-weight: 400 !important;
    line-height: 16px !important;
    padding: 10px 20px !important;
    .ant-tabs-tab-btn {
      color: ${({ theme }) => theme.settings.textColor} !important;
    }
  }
  .ant-tabs-tab-active {
    background: rgba(${({ theme }) => theme.settings.rgbPrimary}, 0.05) !important;
    color: ${({ theme }) => theme.settings.mainColor} !important;
    font-weight: 500 !important;
    .ant-tabs-tab-btn {
      font-weight: 500 !important;
      color: ${({ theme }) => theme.settings.mainColor} !important;
    }
  }
  .ant-tabs-content-holder {
    width: 100%;
    /* min-height: calc(100vh - 400px);
    max-height: calc(100vh - 400px);
    height: 100%;
    @media (max-width: 1200.99px) {
      min-height: 100%;
      max-height: 100%;
    }
    overflow-y: auto;
    &::-webkit-scrollbar {
      width: 2px;
      height: 2px;
    }
    &::-webkit-scrollbar-track {
      background: ${({ theme }) => theme.settings.borderColor};
    }
    &::-webkit-scrollbar-thumb {
      background: ${({ theme }) => theme.settings.mainColor};
    }
    &::-webkit-scrollbar-corner {
      background: ${({ theme }) => theme.settings.borderColor};
    } */
  }
`;
// new style
export const ProjectChatCard = styled(Card)`
  width: 100%;
  position: relative;
  height: 100%;
  background: ${({ theme }) => theme.settings.whiteColor};
  border-radius: 16px;
  border: 1px solid ${({ theme }) => theme.settings.borderColor};
  .ant-card-head {
    border-bottom: 1px solid ${({ theme }) => theme.settings.borderColor} !important;
    padding: 16px 20px !important;
    min-height: auto !important;
    .ant-card-head-title {
      font-family: ${({ theme }) => theme.fonts.inter} !important;
      font-size: 16px;
      font-weight: 600;
      line-height: 20px;
      color: ${({ theme }) => theme.settings.primary};
      span {
        font-size: 12px;
        font-weight: 400;
        line-height: 18px;
        color: ${({ theme }) => theme.settings.secondary};
      }
    }
  }
  &.chatSessionsCard {
    @media (min-width: 1200px) {
      display: flex;
      flex-direction: column;
      height: auto;
    }
    .ant-card-body {
      background: linear-gradient(
        0.34deg,
        rgba(255, 255, 255, 0.2) 0.3%,
        rgba(189, 195, 232, 0.2) 99.7%
      );
      @media (min-width: 1200px) {
        flex: 1 1 auto;
        min-height: 0;
        max-height: var(--chat-card-h, none);
      }
      overflow-y: auto;
      @media (max-width: 1199.99px) {
        max-height: 400px;
      }
      @media (max-width: 768.99px) {
        max-height: none;
      }
      &::-webkit-scrollbar {
        width: 6px;
        height: 6px;
      }
      &::-webkit-scrollbar-track {
        background: transparent;
      }
      &::-webkit-scrollbar-thumb {
        background: ${({ theme }) => theme.settings.primary};
      }
      &::-webkit-scrollbar-corner {
        background: ${({ theme }) => theme.settings.borderColor};
      }
    }
  }
  .ant-card-body {
    padding: 16px 20px;
    /* max-height: calc(100vh - 240px);
    overflow-y: auto;
    @media (max-width: 1200.99px) {
      max-height: 100%;
    }
    &::-webkit-scrollbar {
      width: 2px;
      height: 2px;
    }
    &::-webkit-scrollbar-track {
      background: ${({ theme }) => theme.settings.borderColor};
    }
    &::-webkit-scrollbar-thumb {
      background: ${({ theme }) => theme.settings.mainColor};
    }
    &::-webkit-scrollbar-corner {
      background: ${({ theme }) => theme.settings.borderColor};
    } */
  }
`;
// new style
export const ProjectChatSessionsDetailsCard = styled(Card)`
  width: 100%;
  position: relative;
  background: ${({ theme }) => theme.settings.whiteColor} !important;
  border: 1px solid ${({ theme }) => theme.settings.borderColor};
  border-radius: 12px;
  .totalMassages {
    border: 2px solid ${({ theme }) => theme.settings.borderColor};
    padding: 4px 8px;
  }
  .ant-card-head {
    border-bottom: none !important;
    min-height: auto !important;
    padding: 15px 15px 0px 15px;
    margin-bottom: 0px !important;
    background: transparent !important;
    .ant-card-head-title {
      font-family: ${({ theme }) => theme.fonts.inter} !important;
      font-size: 14px;
      font-weight: 500 !important;
      line-height: 18px;
      color: ${({ theme }) => theme.settings.secondary};
    }
  }
  .ant-card-body {
    padding: 5px 15px 0px 15px;
    height: 100% !important;
    max-height: 100% !important;
    background: transparent !important;
    border: none !important;
    .data {
      font-family: ${({ theme }) => theme.fonts.inter} !important;
      font-size: 12px;
      font-weight: 500 !important;
      line-height: 18px;
      color: ${({ theme }) => theme.settings.primary};
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
      max-width: 100%;
    }
    .avatarWrapper {
      display: flex;
      align-items: center;
      img {
        float: left;
        margin-right: 10px;
      }
      span {
        float: right;
        font-size: 12px;
        font-weight: 400;
        line-height: 30px;
        color: ${({ theme }) => theme.settings.primary};
      }
    }
  }
  &.bodyHeightAuto {
    .ant-card-body {
      height: auto !important;
    }
  }
`;
export const ProjectChatSessionsTag = styled(Tag)`
  background: ${({ theme }) => theme.settings.whiteColor};
  color: ${({ theme }) => theme.settings.primary};
  border: 1px solid ${({ theme }) => theme.settings.borderColor};
  border-radius: 5px;
  font-size: 12px;
  font-weight: 500;
  line-height: 18px;
  display: inline-flex;
  padding: 2px 4px;
  img {
    margin-right: 5px;
  }
`;
// new style
export const DefaultGptCard = styled(Card)`
  width: 100%;
  position: relative;
  height: 100%;
  background: transparent;
  border: none;
  border-radius: 0px !important;
  .ant-card-body {
    padding: 0px;
    height: calc(100vh - 140px);
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    flex-direction: column;
  }
  &.noFlex {
    .ant-card-body {
      height: 100%;
      display: block;
      align-items: flex-center;
      justify-content: flex-start;
      flex-direction: unset;
      padding-top: 5%;
      @media (max-width: 991.99px) {
        padding-top: 10%;
      }
    }
  }
  .mainTitle {
    font-family: ${({ theme }) => theme.fonts.inter} !important;
    font-size: 20px;
    font-weight: 500;
    line-height: 18px;
    color: ${({ theme }) => theme.settings.primary};
  }
  .subTitle {
    font-size: 16px;
    font-weight: 400;
    line-height: 18px;
    color: ${({ theme }) => theme.settings.primary};
  }
`;
// new style
export const ProjectGptChatCard = styled(Card)`
  width: 100%;
  position: relative;
  height: 100%;
  background: ${({ theme }) => theme.settings.whiteColor};
  border: 1px solid ${({ theme }) => theme.settings.borderColor};
  border-radius: 12px !important;
  .ant-card-body {
    padding: 0px;
  }
  .ant-card-head {
    padding: 10px 15px;
    .ant-card-head-title {
      font-family: ${({ theme }) => theme.fonts.inter} !important;
      font-size: 16px;
      font-weight: 500;
      line-height: 16px;
      color: ${({ theme }) => theme.settings.secondary};
    }
  }
  &.smallFont {
    .ant-card-head {
      .ant-card-head-title {
        font-size: 14px !important;
        font-weight: 500 !important;
        line-height: 16px !important;
        color: ${({ theme }) => theme.settings.secondary} !important;
      }
    }
  }
  .scrollable {
    height: calc(100vh - 233px);
    padding: 15px 15px 0px 15px;
    overflow-y: auto;
    &::-webkit-scrollbar {
      width: 2px;
      height: 2px;
    }
    &::-webkit-scrollbar-track {
      background: ${({ theme }) => theme.settings.borderColor};
    }
    &::-webkit-scrollbar-thumb {
      background: ${({ theme }) => theme.settings.primary};
    }
    &::-webkit-scrollbar-corner {
      background: ${({ theme }) => theme.settings.borderColor};
    }
    &.fullHeight {
      height: calc(100vh - 160px);
    }
  }
  .ant-card-actions {
    display: block;
    border-top: none !important;
    padding: 5px 15px 15px 15px;
    li {
      width: 100%;
      margin: 0px !important;
      list-style: none;
    }
  }
  .sentTimeTitle {
    font-size: 12px;
    font-weight: 400;
    line-height: 30px;
    color: ${({ theme }) => theme.settings.textColor};
    margin-right: 20px;
  }
  h6 {
    margin-bottom: 15px;
    font-size: 14px;
    font-weight: 600;
    line-height: 22px;
    color: ${({ theme }) => theme.settings.secondary};
    svg {
      float: left;
      margin-right: 5px;
    }
  }
  p {
    margin-bottom: 15px;
    font-size: 14px;
    font-weight: 400;
    line-height: 22px;
    color: ${({ theme }) => theme.settings.secondary};
  }
  ul {
    li {
      list-style: disc;
      margin-left: 15px;
      margin-bottom: 15px;
      font-size: 14px;
      font-weight: 400;
      line-height: 18px;
      color: ${({ theme }) => theme.settings.secondary};
      span {
        font-weight: 600;
      }
    }
  }
`;
// new style
export const ProjectGptChatMassage = styled.div`
  width: 100%;
  position: relative;
  padding: 0px;
  font-family: ${({ theme }) => theme.fonts.inter};

  &.allMessagesLeft {
    .messageContainer {
      justify-content: flex-start !important;
      > div {
        background-color: transparent !important;
        padding: 0px !important;
      }
    }
  }
  .messageContainer {
    display: flex;
    align-items: flex-start;
    gap: 12px;
    margin-bottom: 15px;
    width: 100%;
    overflow: hidden;

    > div {
      min-width: 0;
      max-width: 100%;
      overflow: hidden;
    }

    &[data-is-user='true'] {
      justify-content: flex-end;

      > div {
        background-color: ${({ theme }) => theme.settings.bodyBg};
        color: ${({ theme }) => theme.settings.whiteColor};
        padding: 8px 12px;
        border-radius: 12px;
        max-width: 96%;
        word-wrap: break-word;

        .messageText {
          color: ${({ theme }) => theme.settings.primary};
        }
      }
    }
    .avatar {
      width: 24px;
      height: 24px;
      border-radius: 50%;
      background: ${({ theme }) => theme.settings.borderColor};
      display: flex;
      align-items: center;
      justify-content: center;
      flex-shrink: 0;
      overflow: hidden;
      padding: 0px !important;
      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
      &.assistant {
        padding: 5px;
        background: ${({ theme }) => theme.settings.whiteColor};
        border: 1px solid ${({ theme }) => theme.settings.borderColor};
        img {
          object-fit: contain;
          width: 100%;
          height: 100%;
        }
      }
    }
  }
  .messageContent {
    flex: 1;
    min-width: 0;
    overflow-wrap: break-word;
    display: flex;
    flex-direction: column;
    strong {
      font-weight: normal;
    }
    ol {
      padding-left: 0px;
    }
  }
  .messageText {
    font-family: ${({ theme }) => theme.fonts.inter};
    font-size: 14px;
    font-weight: 400;
    line-height: 1.5;
    color: ${({ theme }) => theme.settings.primary};
    word-wrap: break-word;
  }
  .messageHeader {
    display: flex;
    align-items: center;
    gap: 8px;
    margin-bottom: 4px;
    font-family: ${({ theme }) => theme.fonts.inter};
    font-size: 14px;
    color: ${({ theme }) => theme.settings.primary};
    .senderName {
      font-family: ${({ theme }) => theme.fonts.inter};
      font-size: 14px;
      line-height: 18px;
      font-weight: 500;
      color: ${({ theme }) => theme.settings.primary};
    }
  }

  .timestamp {
    font-family: ${({ theme }) => theme.fonts.inter};
    font-size: 10px;
    margin-top: 4px;
    color: ${({ theme }) => theme.settings.textColor};
  }
  .messageText {
    font-family: ${({ theme }) => theme.fonts.inter};
    font-size: 14px;
    font-weight: 400;
    line-height: 1.5;
    color: ${({ theme }) => theme.settings.primary};
    word-wrap: break-word;
  }
  .typingIndicator {
    display: flex;
    align-items: center;
    gap: 4px;
    margin-top: 15px;
    .dot {
      width: 4px;
      height: 4px;
      border-radius: 50%;
      background: ${({ theme }) => theme.settings.primary};
      animation: typing 1.4s infinite ease-in-out;
      &:nth-child(1) {
        animation-delay: -0.32s;
      }
      &:nth-child(2) {
        animation-delay: -0.16s;
      }
      &:nth-child(3) {
        animation-delay: 0s;
      }
      &:nth-child(4) {
        animation-delay: 0.16s;
      }
    }
  }
  @keyframes typing {
    0%,
    80%,
    100% {
      transform: scale(0.8);
      opacity: 0.5;
    }
    40% {
      transform: scale(1);
      opacity: 1;
    }
  }
  .clientMessage {
    width: 100%;
    position: relative;
    overflow: hidden;
  }
  .assistantMessage {
    width: 100%;
    position: relative;
    overflow: hidden;
  }
`;
export const ProjectChatMassage = styled.div`
  width: 100%;
  position: relative;
  padding: 0px;
  font-family: ${({ theme }) => theme.fonts.inter};
  .messageContainer {
    display: flex;
    align-items: flex-start;
    gap: 12px;
    margin-bottom: 15px;
    width: 100%;
  }

  .avatar {
    width: 24px;
    height: 24px;
    border-radius: 50%;
    background: ${({ theme }) => theme.settings.borderColor};
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    overflow: hidden;
    &.defaultAvatar {
      width: 24px;
      height: 24px;
      object-fit: cover;
      background: linear-gradient(180deg, #0b4553 0%, #d8922b 100%);
    }
    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
    &.assistant {
      padding: 5px;
      background: ${({ theme }) => theme.settings.whiteColor};
      border: 1px solid ${({ theme }) => theme.settings.borderColor};
      img {
        object-fit: contain;
        width: 100%;
        height: 100%;
      }
    }
  }

  .messageContent {
    flex: 1;
    display: flex;
    flex-direction: column;
  }
  .messageHeader {
    display: flex;
    align-items: center;
    gap: 8px;
    margin-bottom: 4px;
    font-family: ${({ theme }) => theme.fonts.inter};
    font-size: 14px;
    color: ${({ theme }) => theme.settings.primary};
  }
  .senderName {
    font-family: ${({ theme }) => theme.fonts.inter};
    font-size: 12px;
    line-height: 18px;
    font-weight: 600;
    color: ${({ theme }) => theme.settings.primary};
  }
  .timestamp {
    font-family: ${({ theme }) => theme.fonts.inter};
    font-size: 10px;
    margin-top: 4px;
    color: ${({ theme }) => theme.settings.textColor};
  }
  .messageText {
    font-family: ${({ theme }) => theme.fonts.inter};
    font-size: 12px;
    font-weight: 400;
    line-height: 1.5;
    color: ${({ theme }) => theme.settings.primary};
    word-wrap: break-word;
  }
  .typingIndicator {
    display: flex;
    align-items: center;
    gap: 4px;
    margin-top: 15px;
    .dot {
      width: 4px;
      height: 4px;
      border-radius: 50%;
      background: ${({ theme }) => theme.settings.primary};
      animation: typing 1.4s infinite ease-in-out;

      &:nth-child(1) {
        animation-delay: -0.32s;
      }
      &:nth-child(2) {
        animation-delay: -0.16s;
      }
      &:nth-child(3) {
        animation-delay: 0s;
      }
      &:nth-child(4) {
        animation-delay: 0.16s;
      }
    }
  }
  @keyframes typing {
    0%,
    80%,
    100% {
      transform: scale(0.8);
      opacity: 0.5;
    }
    40% {
      transform: scale(1);
      opacity: 1;
    }
  }
  .clientMessage {
    width: 100%;
    position: relative;
  }

  .assistantMessage {
    width: 100%;
    position: relative;
  }
`;
export const DefaultGptSuggestionsCard = styled.span`
  background: ${({ theme }) => theme.settings.whiteColor};
  border: 1px solid ${({ theme }) => theme.settings.borderColor};
  border-radius: 12px;
  box-shadow:
    0px 6px 29px rgba(89, 108, 148, 0.07),
    0px 0.751293px 3.63125px rgba(89, 108, 148, 0.035);
  padding: 12px 20px;
  display: inline-block;
  margin-top: 10px;
  cursor: pointer;
  opacity: 0.6;
  transition: all 0.3s ease;
  img,
  svg {
    color: ${({ theme }) => theme.settings.primary};
    filter: ${({ theme }) => theme.settings.imgFilterColor};
  }
  &:hover {
    transform: translateY(-2px);
    border: 1px solid rgba(46, 69, 218, 0.2);
    /* background: ${({ theme }) => theme.settings.gradientBorder}; */
    opacity: 1;
    box-shadow:
      0px 8px 35px rgba(89, 108, 148, 0.12),
      0px 1px 5px rgba(89, 108, 148, 0.05);
  }
`;
export const DefaultSessionDrawer = styled(Card)`
  width: 100%;
  position: relative;
  border: 1px solid ${({ theme }) => theme.settings.borderColor};
  border-radius: 10px;
  .ant-card-body {
    padding: 10px;
    height: calc(100vh - 200px) !important;
    overflow-y: auto;
    &::-webkit-scrollbar {
      width: 2px;
      height: 2px;
    }
    &::-webkit-scrollbar-track {
      background: ${({ theme }) => theme.settings.borderColor};
    }
    &::-webkit-scrollbar-thumb {
      background: ${({ theme }) => theme.settings.mainColor};
    }
    &::-webkit-scrollbar-corner {
      background: ${({ theme }) => theme.settings.borderColor};
    }
  }
  /* .ant-drawer-close {
    position: absolute;
    top: 24px;
    right: 16px;
    z-index: 1000;
  }
  .ant-drawer-body {
    height: 100% !important;
    overflow-y: auto;
    &::-webkit-scrollbar {
      width: 2px;
      height: 2px;
    }
    &::-webkit-scrollbar-track {
      background: ${({ theme }) => theme.settings.borderColor};
    }
    &::-webkit-scrollbar-thumb {
      background: ${({ theme }) => theme.settings.mainColor};
    }
    &::-webkit-scrollbar-corner {
      background: ${({ theme }) => theme.settings.borderColor};
    }
  } */
`;
// new style
export const ProjectSuggestionsTitle = styled.div`
  font-family: ${({ theme }) => theme.fonts.inter} !important;
  width: 100%;
  position: relative;
  font-size: 14px;
  font-weight: 400;
  color: ${({ theme }) => theme.settings.primary};
  line-height: 18px;
`;
export const ProjectSettingsCard = styled(Card)`
  width: 100%;
  position: relative;
  background: ${({ theme }) => theme.settings.whiteColor};
  border-radius: 0px;
  border: 1px solid transparent;
  &.demographicCard {
    border-radius: 10px;
    border: 1px solid ${({ theme }) => theme.settings.borderColor};
    .ant-card-body {
      padding: 16px 20px;
    }
    .settingsDescription {
      text-align: left;
    }
    .providerOption {
      justify-content: flex-start !important;
      transition: all 0.2s ease;
      transform: translateY(0) !important;
      &.active {
        border: 1px solid ${({ theme }) => theme.settings.mainColor} !important;
        box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2) !important;
        transform: translateY(-2px) !important;
      }
    }
  }
  .ant-card-head {
    border-bottom: 1px solid ${({ theme }) => theme.settings.borderColor} !important;
    padding: 16px 20px !important;
    min-height: auto !important;
    .ant-card-head-wrapper {
      display: flex;
      align-items: flex-start;
      gap: 16px;
    }
    .ant-card-extra {
      padding-top: 0;
      margin-left: auto;
    }
    .ant-card-head-title {
      font-family: ${({ theme }) => theme.fonts.inter} !important;
      font-size: 16px;
      font-weight: 600;
      line-height: 20px;
      color: ${({ theme }) => theme.settings.primary};
      span {
        font-size: 12px;
        font-weight: 400;
        line-height: 18px;
        color: ${({ theme }) => theme.settings.secondary};
      }
    }
  }
  .ant-card-body {
    padding: 0px;
  }
  .settingsLabel {
    font-family: ${({ theme }) => theme.fonts.inter} !important;
    font-size: 14px;
    font-weight: 500;
    line-height: 20px;
    color: ${({ theme }) => theme.settings.primary};
    margin-bottom: 8px;
    display: block;
  }
  .settingsDescription {
    font-family: ${({ theme }) => theme.fonts.inter} !important;
    font-size: 12px;
    font-weight: 400;
    line-height: 18px;
    color: ${({ theme }) => theme.settings.secondary};
    margin-bottom: 12px;
    display: block;
  }
  .providerOption {
    width: 100%;
    display: inline-flex;
    align-items: center !important;
    justify-content: space-between !important;
    gap: 12px;
    padding: 12px 16px;
    border: 1px solid ${({ theme }) => theme.settings.borderColor};
    border-radius: 8px;
    cursor: pointer;
    transition: all 0.2s ease;
    background: ${({ theme }) => theme.settings.whiteColor};
    &:hover {
      background: ${({ theme }) => theme.settings.whiteColor};
      box-shadow:
        0px 6px 29px rgba(89, 108, 148, 0.07),
        0px 0.751293px 3.63125px rgba(89, 108, 148, 0.035);
    }
    &.active {
      background: ${({ theme }) => theme.settings.whiteColor};
      box-shadow:
        0px 6px 29px rgba(89, 108, 148, 0.07),
        0px 0.751293px 3.63125px rgba(89, 108, 148, 0.035);
    }
    .providerIcon {
      width: 32px;
      height: 32px;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .providerName {
      font-family: ${({ theme }) => theme.fonts.inter} !important;
      font-size: 14px;
      font-weight: 500;
      color: ${({ theme }) => theme.settings.primary};
    }
    .providerDesc {
      font-family: ${({ theme }) => theme.fonts.inter} !important;
      font-size: 11px;
      font-weight: 400;
      color: ${({ theme }) => theme.settings.secondary};
    }
  }
`;

// export const SessionSidebar = styled.div`
//   width: 100%;
//   position: relative;
//   overflow: hidden;
//   display: flex;
//   .sessionLeftSidebar {
//     background: ${({ theme }) => theme.settings.whiteColor};
//     display: block;
//     width: ${(props) => (props.hasLeftSidebar ? "3000px" : "0")};
//     min-width: ${(props) => (props.hasLeftSidebar ? "300px" : "0")};
//     max-width: ${(props) => (props.hasLeftSidebar ? "300px" : "0")};
//     position: relative;
//     transition: width 0.3s cubic-bezier(0.4, 0, 0.2, 1),
//       min-width 0.3s cubic-bezier(0.4, 0, 0.2, 1),
//       max-width 0.3s cubic-bezier(0.4, 0, 0.2, 1),
//       opacity 0.3s cubic-bezier(0.4, 0, 0.2, 1);
//     opacity: ${(props) => (props.hasLeftSidebar ? "1" : "0")};
//     visibility: ${(props) => (props.hasLeftSidebar ? "visible" : "hidden")};
//     pointer-events: ${(props) => (props.hasLeftSidebar ? "auto" : "none")};
//     overflow: hidden;

//     /* Hide content when collapsed */
//     > * {
//       transition: opacity 0.2s ease;
//       opacity: ${(props) => (props.hasLeftSidebar ? "1" : "0")};
//     }
//   }

//   .sessionRightSidebar {
//     flex: 1;
//     transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
//     min-width: 0;
//     position: relative;
//     padding: 0px 30px;
//   }
// `;
export const InsightEngineModalTitle = styled.div`
  width: 100%;
  position: relative;
  font-size: 18px;
  font-weight: 600;
  line-height: 24px;
  color: ${({ theme }) => theme.settings.primary};
  &.small {
    font-size: 16px !important;
    span {
      display: inline-block;
      margin-inline-end: 4px;
      color: #ff4d4f;
      font-size: 14px;
      font-family: SimSun, sans-serif;
      line-height: 1;
      content: '*';
      font-weight: 400;
    }
  }
`;
export const InsightEngineModalRadioGroup = styled(Radio.Group)`
  width: 100%;
  position: relative;
  display: flex !important;
  flex-direction: column;
  gap: 6px;

  .ant-radio-wrapper {
    width: 100%;
    margin: 0;
    padding: 10px 12px;
    border: 2px solid ${({ theme }) => theme.settings.borderColor};
    border-radius: 8px;
    background: ${({ theme }) => theme.settings.whiteColor};
    display: flex !important;
    align-items: center !important;
    justify-content: space-between;
    cursor: pointer;
    transition: all 0.2s ease;
    min-height: auto;

    &:hover {
      border-color: ${({ theme }) => theme.settings.mainColor};
    }

    .ant-radio {
      display: none;
    }

    .ant-radio + span {
      flex: 1;
      padding: 0;
      display: flex !important;
      align-items: center !important;
      justify-content: space-between;
      width: 100%;
      min-height: 0;
    }

    .radio-label-content {
      display: flex !important;
      flex-direction: column;
      gap: 2px;
      flex: 1;
      min-height: 0;
      justify-content: center;
      align-items: flex-start;
      padding: 0;

      .radio-title {
        font-family: ${({ theme }) => theme.fonts.inter};
        font-size: 14px;
        font-weight: 600;
        line-height: 18px;
        color: ${({ theme }) => theme.settings.primary};
        transition: color 0.2s ease;
        margin: 0;
      }

      .radio-subtitle {
        font-family: ${({ theme }) => theme.fonts.inter};
        font-size: 12px;
        font-weight: 400;
        line-height: 16px;
        color: ${({ theme }) => theme.settings.textColor};
        transition: color 0.2s ease;
        margin: 0;
      }

      .radio-status {
        margin: 0;
        margin-top: 2px;

        .status-tag-small {
          font-size: 11px !important;
          line-height: 1 !important;
          height: 18px !important;
          padding: 0 6px !important;
          font-weight: 400 !important;
          display: inline-flex !important;
          align-items: center !important;

          .anticon {
            font-size: 10px !important;
          }
        }
      }
    }

    .radio-icon {
      width: 18px;
      height: 18px;
      border-radius: 50%;
      border: 2px solid ${({ theme }) => theme.settings.borderColor};
      display: flex !important;
      align-items: center !important;
      justify-content: center;
      flex-shrink: 0;
      margin-left: 12px;
      transition: all 0.2s ease;

      img {
        display: none;
        width: 10px;
        height: 10px;
      }
    }

    &.ant-radio-wrapper-checked {
      border-color: ${({ theme }) => theme.settings.mainColor};

      .radio-label-content {
        .radio-title {
          color: ${({ theme }) => theme.settings.mainColor};
        }

        .radio-subtitle {
          color: ${({ theme }) => theme.settings.mainColor};
        }
      }

      .radio-icon {
        border-color: ${({ theme }) => theme.settings.mainColor};
        background-color: ${({ theme }) => theme.settings.mainColor};

        img {
          display: block;
          filter: brightness(0) invert(1);
        }
      }
    }

    &:not(.ant-radio-wrapper-checked) {
      .radio-label-content {
        .radio-title {
          color: ${({ theme }) => theme.settings.primary};
        }

        .radio-subtitle {
          color: ${({ theme }) => theme.settings.primary};
        }
      }
    }

    &.ant-radio-wrapper-disabled {
      opacity: 0.6;
      cursor: not-allowed;
      border-style: dashed;
      border-color: ${({ theme }) => theme.settings.borderColor};
      background: ${({ theme }) => theme.settings.backgroundSecondary || '#fafafa'};

      &:hover {
        border-color: ${({ theme }) => theme.settings.borderColor};
      }

      .radio-label-content {
        .radio-title {
          color: ${({ theme }) => theme.settings.primary};
        }

        .radio-subtitle {
          color: ${({ theme }) => theme.settings.primary};
        }
      }

      .radio-icon {
        opacity: 0.5;
      }

      .disabled-indicator {
        display: flex;
        align-items: center;
        gap: 4px;
        margin-top: 4px;
        font-size: 11px;
        color: #999;

        .anticon {
          font-size: 12px;
        }
      }
    }
  }
`;

export const ProjectListScrollable = styled.div`
  max-height: 260px;
  overflow-y: auto;
  overflow-x: hidden;
  padding-right: 4px;

  &::-webkit-scrollbar {
    width: 4px;
  }

  &::-webkit-scrollbar-track {
    background: ${({ theme }) => theme.settings.borderColor || '#f1f1f1'};
    border-radius: 2px;
  }

  &::-webkit-scrollbar-thumb {
    background: ${({ theme }) => theme.settings.mainColor || '#888'};
    border-radius: 2px;

    &:hover {
      background: ${({ theme }) => theme.settings.mainColor || '#555'};
    }
  }
`;

export const HistoryList = styled.div`
  width: 100%;
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 12px;
`;
export const HistoryItem = styled.div`
  width: 100%;
  position: relative;
  background: ${({ theme }) => theme.settings.whiteColor};
  border: 1px solid ${({ theme }) => theme.settings.borderColor};
  border-radius: 12px;
  padding: 14px 16px;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  cursor: pointer;
  transition: all 0.2s ease;
  gap: 12px;

  &:hover {
    box-shadow: 0px 2px 8px rgba(50, 50, 50, 0.08);
    border-color: ${({ theme }) => theme.settings.primary};
  }

  .history-left {
    display: flex;
    flex-direction: column;
    gap: 4px;
    flex: 1;
    min-width: 0;

    .messages-info {
      width: fit-content;
      display: inline-flex;
      align-items: center;
      gap: 6px;
      border: 1px solid ${({ theme }) => theme.settings.borderColor};
      border-radius: 10px;
      padding: 2px 8px;
      margin-bottom: 4px;
      img {
        width: 14px;
        height: 14px;
        object-fit: contain;
        flex-shrink: 0;
        display: block;
      }

      span {
        font-family: ${({ theme }) => theme.fonts.inter} !important;
        font-size: 12px;
        font-weight: 400;
        line-height: 20px;
        color: ${({ theme }) => theme.settings.secondary};
        white-space: nowrap;
      }
    }

    .topic-title {
      font-family: ${({ theme }) => theme.fonts.inter} !important;
      font-size: 12px;
      font-weight: 500;
      line-height: 20px;
      color: ${({ theme }) => theme.settings.primary};
      margin: 0;
      padding: 0;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      height: 20px;
      display: flex;
      align-items: center;
    }
  }

  .history-right {
    display: flex;
    align-items: center;
    gap: 6px;
    flex-shrink: 0;
    margin-top: 30px;
    img {
      width: 14px;
      height: 14px;
      object-fit: contain;
      flex-shrink: 0;
      display: block;
    }

    span {
      font-family: ${({ theme }) => theme.fonts.inter} !important;
      font-size: 12px;
      font-weight: 400;
      line-height: 20px;
      color: ${({ theme }) => theme.settings.textColor};
      white-space: nowrap;
    }
  }
`;
export const LibraryList = styled.div`
  width: 100%;
  position: relative;
  margin-bottom: 18px;
  .listItems {
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    font-weight: 400;
    line-height: 20px;
    color: ${({ theme }) => theme.settings.primary};
    border: 1px solid ${({ theme }) => theme.settings.borderColor};
    padding: 10px;
    border-radius: 12px;
    margin-bottom: 10px;
    span {
      font-weight: 500;
    }
    svg {
      margin-right: 10px;
      color: ${({ theme }) => theme.settings.mainColor};
      font-size: 2rem;
      border-radius: 10px !important;
    }
  }
`;
export const ProjectFiles = styled.div``;

export const InsightComposerShell = styled.div`
  flex: 1;
  position: relative;
  border-radius: 999px;
  border: 1px solid ${({ theme }) => theme.settings.borderColor};
  background: ${({ theme }) => theme.settings.whiteColor};
  min-height: 52px;
  padding: 12px 64px 12px 16px;
  box-shadow:
    0px 6px 29px rgba(89, 108, 148, 0.07),
    0px 0.751px 3.631px rgba(89, 108, 148, 0.04);
  display: flex;
  align-items: center;
`;

export const InsightStyledTextArea = styled(Input.TextArea).attrs({
  autoSize: { minRows: 1, maxRows: 4 },
  bordered: false,
})`
  && {
    width: 100%;
    background: transparent;
  }

  && textarea {
    border: none !important;
    box-shadow: none !important;
    resize: none !important;
    background: transparent !important;
    padding: 0 !important;
    font-family: ${({ theme }) => theme.fonts.inter};
    font-size: 14px;
    line-height: 22px;
    color: ${({ theme }) => theme.settings.primary};
  }

  && textarea::placeholder {
    color: #9ca3af;
    opacity: 1;
    font-style: italic;
  }

  && textarea:focus {
    outline: none;
  }
`;

export const InsightSendButton = styled.button`
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  width: 38px;
  height: 38px;
  border-radius: 50%;
  border: none;
  /* background: #2E45DA; */
  background: ${({ theme }) => theme.settings.cta_hover};
  color: ${({ theme }) => theme.settings.whiteColor};
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  cursor: pointer;
  /* box-shadow:
    inset 0px 4px 10px rgba(119, 88, 175, 0.6),
    0px 8px 24px rgba(46, 69, 218, 0.25); */
  box-shadow: 0px 12px 18px rgba(88, 115, 220, 0.3);
  transition:
    transform 0.2s ease,
    opacity 0.2s ease;

  &:hover:not(:disabled) {
    transform: translateY(-50%) translateY(-1px);
  }

  &:disabled {
    opacity: 0.4;
    cursor: not-allowed;
  }

  img {
    width: 18px;
    height: 18px;
  }
`;

export const FeedbackButtonsWrapper = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  row-gap: 4px;
  gap: 2px;
  margin-top: 8px;
`;

export const FeedbackButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  border-radius: 6px;
  border: none;
  background: transparent;
  cursor: pointer;
  transition: all 0.15s ease;
  padding: 0;

  svg {
    width: 16px;
    height: 16px;
    color: #9ca3af;
    transition: all 0.15s ease;
  }

  &:hover {
    background: rgba(0, 0, 0, 0.05);

    svg {
      color: ${({ theme }) => theme.settings.primary};
    }
  }

  &.active-up,
  &.active-down {
    svg {
      color: ${({ theme }) => theme.settings.primary};
    }
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

export const ScrollToBottomButton = styled.button`
  position: sticky;
  bottom: 20px;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  border: 1px solid #e5e5e5;
  background: white;
  cursor: pointer;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.12);
  transition: all 0.2s ease;
  z-index: 10;
  margin-top: -50px;

  svg {
    width: 16px;
    height: 16px;
    color: #666;
  }

  &:hover {
    background: #f5f5f5;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
    svg {
      color: #333;
    }
  }

  &:active {
    transform: translateX(-50%) scale(0.95);
  }
`;

// Folder styles
export const FolderSectionLabel = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 16px;
  font-family: ${({ theme }) => theme.fonts.inter} !important;
  font-size: 16px;
  font-weight: 600;
  line-height: 20px;
  /* color: #485066; */
  color: ${({ theme }) => theme.settings.textColor};
  user-select: none;
  img,
  svg {
    width: 16px;
    height: 16px;
    color: ${({ theme }) => theme.settings.mainColor};
    filter: ${({ theme }) => theme.settings.imgFilterColor};
  }
  .collapse-arrow {
    margin-left: 4px;
    display: flex;
    align-items: center;
    padding: 4px 6px;
    border-radius: 4px;
    &:hover {
      background: rgba(0, 0, 0, 0.04);
    }
    svg {
      width: 12px;
      height: 12px;
      color: #485066;
      transition: transform 0.2s ease;
    }
  }
`;

export const FolderBackNav = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 16px;
  .back-arrow {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 14px;
    height: 14px;
    cursor: pointer;
    svg {
      font-size: 14px;
      color: #485066;
    }
  }
  .folder-name {
    font-family: ${({ theme }) => theme.fonts.inter} !important;
    font-size: 16px;
    font-weight: 600;
    line-height: 20px;
    color: #485066;
    min-width: 0;
  }
`;

export const ThemeFolderCard = styled.div`
  width: 100%;
  min-height: 60px;
  display: flex;
  align-items: center;
  border: 1px solid #e8eaf6;
  border-radius: 10px;
  background: ${({ theme }) => theme.settings.whiteColor};
  box-shadow:
    0px 6px 29px rgba(89, 108, 148, 0.07),
    0px 0.751293px 3.63125px rgba(89, 108, 148, 0.04);
  cursor: pointer;
  transition: all 0.2s ease;
  overflow: hidden;

  &:hover {
    box-shadow: 0px 4px 12px rgba(50, 50, 50, 0.1);
  }

  &.drag-over {
    border: 2px dashed #2e45da;
    background: rgba(46, 69, 218, 0.06);
    box-shadow: 0px 4px 16px rgba(46, 69, 218, 0.15);
    transform: scale(1.02);
  }

  .folder-icon-wrapper {
    width: 60px;
    min-height: 60px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: rgba(232, 234, 246, 0.36);
    border-radius: 10px 0 0 10px;
    flex-shrink: 0;
    img,
    svg {
      width: 24px;
      height: 24px;
    }
  }

  .folder-name {
    flex: 1;
    padding: 0 12px;
    font-family: ${({ theme }) => theme.fonts.inter} !important;
    font-size: 16px;
    font-weight: 500;
    line-height: 20px;
    color: #2c2926;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .folder-menu {
    padding: 0 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    flex-shrink: 0;
    svg {
      font-size: 16px;
      color: ${({ theme }) => theme.settings.secondary};
    }
  }
`;

export const FolderContextMenu = styled.div`
  background: ${({ theme }) => theme.settings.whiteColor};
  border: 1px solid #e2e8ee;
  border-radius: 20px;
  padding: 12px 0;
  min-width: 160px;
  box-shadow:
    0px 6px 29px rgba(89, 108, 148, 0.07),
    0px 0.751293px 3.63125px rgba(89, 108, 148, 0.04);

  .menu-item {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 10px 20px;
    cursor: pointer;
    transition: background 0.2s ease;
    font-family: ${({ theme }) => theme.fonts.inter} !important;
    font-size: 14px;
    font-weight: 500;
    line-height: 18px;
    color: #2c2926;

    &:hover {
      background: rgba(0, 0, 0, 0.04);
    }

    img,
    svg {
      width: 16px;
      height: 16px;
    }

    &.danger {
      color: #e65b5b;
      svg {
        color: #e65b5b;
      }
    }
  }
`;

export const FolderListScrollable = styled.div`
  max-height: 300px;
  overflow-y: auto;
  padding-right: 4px;
  display: flex;
  flex-direction: column;
  gap: 8px;

  &::-webkit-scrollbar {
    width: 4px;
  }
  &::-webkit-scrollbar-track {
    background: ${({ theme }) => theme.settings.borderColor || '#f1f1f1'};
    border-radius: 2px;
  }
  &::-webkit-scrollbar-thumb {
    background: ${({ theme }) => theme.settings.mainColor || '#888'};
    border-radius: 2px;
  }
`;

export const FolderRadioGroup = styled(Radio.Group)`
  width: 100%;
  display: flex !important;
  flex-direction: column;
  gap: 6px;

  .ant-radio-wrapper {
    width: 100%;
    margin: 0;
    padding: 10px 12px;
    border: 1px solid ${({ theme }) => theme.settings.borderColor};
    border-radius: 10px;
    background: ${({ theme }) => theme.settings.whiteColor};
    display: flex !important;
    align-items: center !important;
    cursor: pointer;
    transition: all 0.2s ease;

    &:hover {
      border-color: rgba(46, 69, 218, 0.3);
    }

    &.ant-radio-wrapper-checked {
      border-color: #2e45da;
      background: rgba(46, 69, 218, 0.04);
    }

    .ant-radio-checked .ant-radio-inner {
      border-color: #2e45da !important;
      background-color: #2e45da !important;
    }

    .ant-radio:hover .ant-radio-inner {
      border-color: #2e45da;
    }

    .ant-radio-checked::after {
      border-color: #2e45da;
    }
  }
`;
